import { render, staticRenderFns } from "./NuevoPuesto.vue?vue&type=template&id=27b20db8&"
import script from "./NuevoPuesto.vue?vue&type=script&lang=js&"
export * from "./NuevoPuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports